import React from 'react';
import classNames from 'classnames';

import classes from './index.module.less';

interface Props {
	className?: string;
	children?: React.ReactNode;
}

const Chips = ({ className = '', children }: Props) => {
	return <span className={classNames(classes.chips, className)}>{children}</span>;
};

export default Chips;
